import { IPendency } from 'modules/customer/domain/entities';

export interface IVectisPendency {
  id: number;
  idUnidade: number;
  cdContrato: string;
  descricaoItensContrato: string[];
  contas: Array<{
    id: number;
    valor: number;
    numeroParcela: number;
    vencida: boolean;
    vencimento: string;
    valorFinal: number;
    valorMulta: number;
  }>;
}

export class Pendency implements IPendency {
  public id: IPendency['id'];
  public unitId: IPendency['unitId'];
  public cdContrato: IPendency['cdContrato'];
  public areas: IPendency['areas'];
  public accounts: IPendency['accounts'];

  constructor(pendency: IVectisPendency) {
    this.id = pendency.id;
    this.unitId = pendency.idUnidade;
    this.cdContrato = pendency.cdContrato;
    this.areas = pendency.descricaoItensContrato;
    this.accounts = pendency.contas.map(account => ({
      id: account.id,
      value: { initial: account.valor, withInterest: account.valorFinal },
      expiry: account.vencimento,
      number: account.numeroParcela,
      status: account.vencida ? 'OVERDUE' : 'PENDING',
      fine: {
        value: account.valorMulta,
      },
      hasFineOrInterest:
        account.vencida && account.valor !== account.valorFinal,
    }));
  }
}
